<template>
  <div class="storeForm">

    <el-form
      v-if="form.fStockID"
      ref="form"
      :model="form"
      :rules="rules"
      label-width="120px"
    >
      <el-form-item label="仓库名称" prop="fName">
        <el-input v-model="form.fName" />
      </el-form-item>
      <el-form-item label="备注" prop="fDes">
        <el-input v-model="form.fDes" />
      </el-form-item>
      <el-form-item label="创建人" prop="fCreater">
        <el-input v-model="form.fCreater" disabled />
      </el-form-item>
      <el-form-item label="创建时间" prop="fCreateTime">
        <el-input v-model="form.fCreateTime" disabled />
      </el-form-item>
      <el-form-item label="最后修改人" prop="fModify">
        <el-input v-model="form.fModify" disabled />
      </el-form-item>
      <el-form-item label="最后修改时间" prop="fModifyTime">
        <el-input v-model="form.fModifyTime" disabled />
      </el-form-item>
    </el-form>
    <el-form v-else ref="form" :model="form" :rules="rules" label-width="120px">
      <el-form-item label="仓库名称" prop="fName">
        <el-input v-model="form.fName" />
      </el-form-item>
      <el-form-item label="备注" prop="fDes">
        <el-input v-model="form.fDes" />
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    form: Object
  },
  data: function() {
    return {
      rules: {
        fName: [{ required: true, message: '必填项', trigger: 'change' }]
        // fDes: [{ required: true, message: '必填项', trigger: 'change' }]
      }
    }
  },
  mounted() {
    // console.log(this.form, 'form')
  },
  methods: {
    submit: function(onValid, onSuccess, onFailed, onComplete) {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const data = Object.assign({}, this.form)
          onValid(data)
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang='less'>
.storeForm{
.el-input.is-disabled .el-input__inner {
     background-color: #F5F7FA;
    border-color: #E4E7ED;
    color: #000;
    cursor: not-allowed;
}
}
</style>
